import {bootboxConfirm} from "../../backend/before";

const Wishlist = () => {
    const main = document.getElementById('wishlist');

    if (!main) return;

    const element =  {
        btnRemoveWishlistClass: '.btn-remove-wishlist'
    };

    $(element.btnRemoveWishlistClass).click(function (e) {
        e.preventDefault();

        const productRef = $(this).data('pref');

        if (!productRef) return;

        bootboxConfirm("Remove product", "Do you really want to remove this product from your wishlist?", () => {
            window.location = `/user/wishlist/${productRef}/remove`;
        })
    });
};

$(() => {
    Wishlist();
});
